import { orchestrator } from 'satcheljs';
import { setSelectedLinkedCalendarsCount } from '../mutators/setSelectedLinkedCalendarsCountMutator';
import { linkedCalendarSelected } from '../actions/internalActions';
import { getSelectedLinkedCalendarsCount } from '../selectors/getSelectedLinkedCalendarsCount';
import { managePollingForLinkedCalendars } from 'owa-calendar-events-store';

orchestrator(linkedCalendarSelected, actionMessage => {
    const currentSelectedLinkedCalendarsCount = getSelectedLinkedCalendarsCount();
    const isSelected = actionMessage.isSelected;

    if (currentSelectedLinkedCalendarsCount == 0 && isSelected) {
        managePollingForLinkedCalendars(isSelected);
    } else if (currentSelectedLinkedCalendarsCount == 1 && !isSelected) {
        managePollingForLinkedCalendars(isSelected);
    }

    setSelectedLinkedCalendarsCount(isSelected, actionMessage.forceReset);
});
